<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page template-padding container" v-else-if="loaded" >
        
        <!-- 
            
            tracked revenue < 50k euro => 1.5% lower cap - 0.6% higher cap
            tracked revenue > 50k euro => 1% lower cap

            Tracked Revenue 0 - 15k euro => 100 euro ( 0.66% higher cap )
            Tracked Revenue 15k - 25k euro => 200 euro ( 1.33% - 0.8% )
            Tracked Revenue 25k - 50k euro => 350 euro ( 1.4% - 0.7% )
            Tracked Revenue 50k - 75k euro => 500 euro ( 1% - 0.66% )
            Tracked Revenue 75k - 100k euro => 750 euro ( 1% - 0.75% )
            Tracked Revenue 100k - 150k euro => 1000 euro ( 1% - 0.66% )

        -->
        
        <div class="row" >
            
            <div class="col-12 text-center" >
                <h4 class="graymedium-color font-900 mt-2" > PRICING PLANS </h4>
            
                <div class='mt-5 mb-3' style="font-size: 14px;" >
                    <p class="mt-2" > 
                        Prices are calculated based on the revenue ( income ) tracked: sales that are tracked and attributed by Atlass.
                        <br><br>
                        Plans scale with your growth
                        <!--
                        Ranges are between <b> 1.4% - 0.6% </b> for tracked revenue <b> below 50k€ </b> and between <b> 1% and 0.6% </b> for revenue over <b> 50k€ </b>.
                        -->
                    </p>
                </div>
            </div>

        </div>
        
        <div class="row pricing mt-5" >
            
            <div class="col pricing-col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > STARTER </h5>
                
                <h1 class="text-300 graymedium-color mt-5" style="font-size: 1.5rem; text-decoration: line-through;" > 199€<span class=" text-300" > /month </span> </h1>
                <h1 class="font-700 main-color " style="font-size: 3.2rem" > 
                    <span class="pricing-offer badge badge-danger text-uppercase">Early bird</span>
                    99€<span class="h4 font-300" > /month </span> 
                </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" >  </span>  -  </h2>
                
                <h6 class="graymedium-color font-900 mt-5 d-none" > .6% max cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 0 - 15k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 0 </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 15,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col pricing-col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > INTERMEDIATE </h5>
                
                <h1 class="text-300 graymedium-color mt-5" style="font-size: 1.5rem; text-decoration: line-through;" > 399€<span class=" text-300" > /month </span> </h1>
                <h1 class="font-700 main-color " style="font-size: 3.2rem" > 
                    <span class="pricing-offer badge badge-danger text-uppercase">Early bird</span>
                    199€<span class="h4 font-300" > /month </span> 
                </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" > or </span> 499€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 d-none" > 1.4% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 15k - 25k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 15,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 25,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col pricing-col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > ADVANCED </h5>
                
                <h1 class="text-300 graymedium-color mt-5" style="font-size: 1.5rem; text-decoration: line-through;" > 699€<span class=" text-300" > /month </span> </h1>
                <h1 class="font-700 main-color " style="font-size: 3.2rem" > 
                    <span class="pricing-offer badge badge-danger text-uppercase">Early bird</span>
                    349€<span class="h4 font-300" > /month </span> 
                </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4 " > or </span> 899€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 d-none" > 1.4% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 25k - 50k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 25,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 50,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col pricing-col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > PROFFESIONAL </h5>
                
                <h1 class="text-300 graymedium-color mt-5" style="font-size: 1.5rem; text-decoration: line-through;" > 999€<span class=" text-300" > /month </span> </h1>
                <h1 class="font-700 main-color " style="font-size: 3.2rem" > 
                    <span class="pricing-offer badge badge-danger text-uppercase">Early bird</span>
                    499€<span class="h4 font-300" > /month </span> 
                </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" > or </span> 1249€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 d-none" > 1% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 50k - 75k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 50,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 75,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col pricing-col text-center border-gray pt-5 pb-5 d-none" >
                <h5 class="graymedium-color mt-2" > ENTERPRISE </h5>
                
                <h1 class="text-300 graymedium-color mt-5" style="font-size: 1.5rem; text-decoration: line-through;" > 1499€<span class=" text-300" > /month </span> </h1>
                <h1 class="font-700 main-color " style="font-size: 3.2rem" > 
                    <span class="pricing-offer badge badge-danger text-uppercase">Early bird</span>
                    749€<span class="h4 font-300" > /month </span> 
                </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" > or </span> 2000€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 d-none" > 1% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 75k - 100k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 50,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 75,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col pricing-col text-center border-gray pt-5 pb-5 d-none" >
                <h5 class="graymedium-color mt-2" > ULTIMATE </h5>
                
                <h1 class="text-300 graymedium-color mt-5" style="font-size: 1.5rem; text-decoration: line-through;" > 2499€<span class=" text-300" > /month </span> </h1>
                <h1 class="font-700 main-color " style="font-size: 3.2rem" > 
                    <span class="pricing-offer badge badge-danger text-uppercase">Early bird</span>
                    999€<span class="h4 font-300" > /month </span> 
                </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" > or </span> 2749€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 d-none" > 1% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 100k - 150k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 50,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 75,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
        </div>
        
        <div id="paypal-button-container-P-3J919307A42900203MH4OVXQ"></div>
        
    </div>
</template>

<script src="https://www.paypal.com/sdk/js?client-id=ARZ9Xfo3hIVaA4YeBgdXRaXwwWErEnsvVZbA3f_RnHRmBPULflBY6LUZAZOlN2p9DbGA2YInkhrDMjo9&vault=true&intent=subscription" data-sdk-integration-source="button-factory"></script>
<script>
  paypal.Buttons({
      style: {
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'paypal'
      },
      createSubscription: function(data, actions) {
        return actions.subscription.create({
          /* Creates the subscription */
          plan_id: 'P-3J919307A42900203MH4OVXQ'
        });
      },
      onApprove: function(data, actions) {
        alert(data.subscriptionID); // You can add optional success message for the subscriber here
      }
  }).render('#paypal-button-container-P-3J919307A42900203MH4OVXQ'); // Renders the PayPal button
</script>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';

export default {
    name: 'Pricing',
    components:{
        
    },
    props: {
    },
    data: function(){
        return {
            loaded: false,
            data:{},
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //this.get_data();
        
        let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        this.data.organizationID = orgID;
        
        setTimeout(function(){ this.loaded = true }.bind(this), 100 );
        
    },
    beforeDestroy() {
    },
    methods: {
         get_data(){
          
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )
                        
            const db = firebase.firestore();
            var ref = db.collection('users').doc( user.userID )
            
            return ref.get()
                .then((snapshot) => {
                    console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.id = snapshot.id
                    this.loaded = true;
                })
          
        },
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        routePrimaryLead(ID){
            this.$router.push({
                name: 'LeadPage',
                params: { ID: ID }
            });
        },
        submit(){
            console.log( this.data )
        },
        copyScript(){
            
            var range = document.createRange();
            range.selectNode(document.getElementById("script"));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        }
    },
    watch: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .pricing .col{
        margin-left: 5px;
    }
    .pricing .col:first-of-type{
        margin-left: 0;
    }
    
    .pricing-offer{
        display: inline-block;
        position: absolute;
        font-size: 10px;
        left: 5%;
        transform: rotate(-30deg);
    }
</style>



// WEBPACK FOOTER //
// src/templates/settings/Pricing.vue